import { Reducer } from "redux";
import { isRoutingEvent } from "../routing_events";
import { REVIZTO_ISSUE_CREATION_DIALOG_DISMISSED, ReviztoIssueCreationDialogDismissedEvent } from "../../events/viewer/revizto_issue_creation_dialog_dismissed";
import { REVIZTO_ISSUE_CREATION_DIALOG_SHOWN, ReviztoIssueCreationDialogShownEvent } from "../../events/viewer/revizto_issue_creation_dialog_shown";
import PlannedBuildingElement from "../../models/domain/planned_building_element";


export type ReviztoIssueCreationDialogStore = {
  open: boolean
  globalId?: string;
  selectedElements?: PlannedBuildingElement[];
}

type Events =
  | ReviztoIssueCreationDialogDismissedEvent
  | ReviztoIssueCreationDialogShownEvent

const reduceReviztoIssueCreationDialog: Reducer<ReviztoIssueCreationDialogStore, Events> = (reviztoIssueCreationDialog = { open: false }, event) => {
  if (isRoutingEvent(event)) {
    return { open: false };
  }
  switch (event.type) {
    case REVIZTO_ISSUE_CREATION_DIALOG_SHOWN: {
      return {
        ...reviztoIssueCreationDialog,
        open: true,
        globalId: event.payload.globalId,
        selectedElements: event.payload.selectedElements
      };
    }
    case REVIZTO_ISSUE_CREATION_DIALOG_DISMISSED: {
      return {
        ...reviztoIssueCreationDialog,
        open: false,
      };
    }

    default: {
      return reviztoIssueCreationDialog;
    }
  }
};

export default reduceReviztoIssueCreationDialog;
